import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const useGetContactCycleLang = ({ filter }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [contactCycleLangList, setContactCycleLangList] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const getContactCycleLang = async ({ filter }) => {

        setIsLoading(true);

        await fetch(`${apiUrlTranslation}?action=getContactCycleLang&filter=${filter}&yap`)
            .then(res => res.json())
            .then(res => setContactCycleLangList(res))
            .then(() => setIsLoading(false))
    }

    useEffect(() => {
        getContactCycleLang({ filter }).then(() => {
            setIsLoading(false);
        });

    }, [i18n.resolvedLanguage])

    return { contactCycleLangList, getContactCycleLang, isLoading }
}

export default useGetContactCycleLang;